import { render, staticRenderFns } from "./WelcomeModal.vue?vue&type=template&id=ab1d8a54"
import script from "./WelcomeModal.vue?vue&type=script&lang=ts"
export * from "./WelcomeModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports